<template>
    <div class="container pt-2">
        <PageTitle main="Rastreio" sub="Atualizar status do rastreio" />
        <b-form>
            <input id="log-id" type="hidden" v-model="log.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Código de Rastreio:" label-for="log-transporte">
                        <b-form-select id="log-transporte" :options="transportes"
                            v-model="log.transporte" required
                            placeholder="Informe o código de rastreio." v-on:change="loadLogs"
                            class="textInput"/>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Status:" label-for="log-status">
                        <b-button variant="outline-success" class="botaoInput" @click="setStatus" v-if="!btnDisable">Ir para: {{ nextStatus }}</b-button>
                        <b-button variant="outline-warning" class="ml-2 botaoInput" @click="reset">Limpar</b-button>
                    </b-form-group>
                </div>
            </div>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-logs" 
                class="text-center table table-sm" 
                :items="logs.length>0?logs:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-logs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-logs" 
                class="text-center table table-sm" 
                :items="logs.length>0?logs:[]" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="danger" class="mr-2 btn-sm mb-1 btn-size" @click="remove(data.item)">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-logs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'statusRastreio',
    components: { PageTitle },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            quemRecebeu: '',
            nome: '',
            email: '',
            status: {},
            statuses: [],
            transportes: [],
            log: {},
            logs: [],
            nextStatus: '',
            rastreio: {},
            local: {},
            btnDisable: true,
            codRastreio: '',
            fields: [
                { key: 'transporte', label: 'Rastreio', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'status', label: 'Status', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'data', label: 'Data', sortable: true, formatter: 'formatData', thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        ...mapState(['user']),
        rows() {
            return this.logs.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        setStatus() {
            this.local.transporte = this.log.transporte
            this.local.status = this.nextStatus

            axios['post'](`${baseApiUrl}/backend/log_transportes.php`, this.local)
                .then(() => {

                    // DESTINO (CLIENTE)
                    const tipo1 = `?tipo=novoStatusCliente`
                    const destinoEmail1 = `&destinoEmail=${this.transporte.email_destino}`
                    const destinoNome1 = `&destinoNome=${this.transporte.destino}`
                    const rastreio1 = `&rastreio=${this.transporte.rastreio}`
                    const status1 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailCliente.php
                        ${tipo1}${destinoEmail1}${destinoNome1}${rastreio1}${status1}`).then(() => {})

                    // ORIGEM (CLIENTE)
                    const tipo2 = `?tipo=novoStatusCliente`
                    const destinoEmail2 = `&destinoEmail=${this.transporte.email_origem}`
                    const destinoNome2 = `&destinoNome=${this.transporte.origem}`
                    const rastreio2 = `&rastreio=${this.transporte.rastreio}`
                    const status2 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailCliente.php
                        ${tipo2}${destinoEmail2}${destinoNome2}${rastreio2}${status2}`).then(() => {})

                    // MOTORISTA (MOTORISTA)
                    const tipo3 = `?tipo=novoStatusMotorista`
                    const destinoEmail3 = `&destinoEmail=${this.email}`
                    const destinoNome3 = `&destinoNome=${this.nome}`
                    const rastreio3 = `&rastreio=${this.transporte.rastreio}`
                    const status3 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailMotorista.php
                        ${tipo3}${destinoEmail3}${destinoNome3}${rastreio3}${status3}`).then(() => {})

                    // RESPONSAVEL (FUNCIONARIO)
                    const tipo4 = `?tipo=novoStatusFuncionario`
                    const destinoEmail4 = `&destinoEmail=${this.transporte.email_responsavel}`
                    const destinoNome4 = `&destinoNome=${this.transporte.responsavel}`
                    const rastreio4 = `&rastreio=${this.transporte.rastreio}`
                    const status4 = `&status=${this.transporte.next_status}`
                    axios.get(`${baseApiUrl}/backend/mailFuncionario.php
                        ${tipo4}${destinoEmail4}${destinoNome4}${rastreio4}${status4}`).then(() => {})

                    this.$toasted.global.defaultSuccess({ message : 'Log inserido com sucesso!' })
                    this.loadLogs()
                })
                .catch(
                    (e) => {
                    this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                }
            )
        },
        loadTransportes() {
            const url = `${baseApiUrl}/backend/transportes.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.transportes = res.data.map(transporte => {
                        return { ...transporte, value: transporte.rastreio, text: transporte.rastreio }
                    })
                }else{
                    this.transportes.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadStatuses() {
            const url = `${baseApiUrl}/backend/status.php`
            axios.get(url).then(res => {
                if(res.data['dados']!=='Não há dados disponíveis'){
                    this.statuses = res.data.map(status => {
                        return { ...status, value: status.nome, text: status.nome }
                    })
                }else{
                    this.statuses.push({ value: 'null', text: 'Não há dados disponíveis' })
                }
            })
        },
        loadLogs() {
            const codigo = this.log.transporte
            if(codigo){
                const url = `${baseApiUrl}/backend/logByRastreio.php?rastreio=${codigo}`
                axios.get(url).then(res => {
                    this.logs = res.data
                    if(this.logs.length > 0){
                        this.exibeRodape = false
                    }else{
                        this.exibeRodape = true
                    }
                    axios.get(`${baseApiUrl}/backend/dadosRastreio.php?rastreio=${codigo}`).then(res => {
                        this.rastreio = res.data[0]

                        const transporte = this.rastreio.id
                        axios.get(`${baseApiUrl}/backend/lastStatusByRastreio.php?transporte=${transporte}`).then(res => {
                            this.status = res.data[0]
                            const currStatus = this.status.id_status
                            const hoje = new Date()
                            const prazo = new Date(this.status.data)
                            this.ultimaAtualizacao = Math.round(((hoje - prazo) / 1000 / 60 / 60 / 24), 0)

                            if (this.status.final === "1") {
                                this.nextStatus = ''
                                this.btnDisable = true
                            } else {
                                this.btnDisable = false
                                axios.get(`${baseApiUrl}/backend/nextStatus.php?id=${currStatus}`).then(res => {
                                    this.nextStatus = res.data[0].titulo
                                })
                            }
                        })
                    })
                })
            }else{
                const url = `${baseApiUrl}/backend/log.php`
                axios.get(url).then(res => {
                    this.logs = res.data
                    if(this.logs.length > 0){
                        this.exibeRodape = false
                    }else{
                        this.exibeRodape = true
                    }
                })
            }
        },
        reset() {
            this.log = {}
            this.loadLogs()
            this.btnDisable = true
        },
        remove(log) {
            const sure = confirm("Deseja realmente excluir o item de status?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/log_transportes.php`
                axios.delete(url, { data: log })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Log excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadLog(log) {
            this.log = { ...log }
        },
        formatData(value) {
            const arr = value.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadLogs()
        this.loadStatuses()
        this.loadTransportes()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.logs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label {
    font-size: 0.8rem;
}
</style>